import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReduce = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9228 23.578L14.9836 16.2052C14.7888 15.4646 15.4647 14.7889 16.2053 14.9838L23.5765 16.9242C24.1412 17.0729 24.0366 17.9037 23.4527 17.9078L19.9179 17.9322C19.7451 17.9333 19.5775 17.9564 19.4177 17.9988L23.7081 22.2887C24.0986 22.6792 24.0986 23.3124 23.7081 23.7029C23.3176 24.0935 22.6844 24.0935 22.2939 23.703L18.0005 19.41C17.9568 19.572 17.933 19.7422 17.9317 19.9177L17.9063 23.4544C17.9021 24.0382 17.0713 24.1426 16.9228 23.578Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.07869 23.578L9.01785 16.2052C9.21264 15.4646 8.53674 14.7889 7.79617 14.9838L0.424944 16.9242C-0.139732 17.0729 -0.0351223 17.9037 0.548776 17.9078L4.08359 17.9322C4.25639 17.9333 4.42399 17.9564 4.58373 17.9988L0.293378 22.2887C-0.0971545 22.6792 -0.0971689 23.3124 0.293346 23.7029C0.683863 24.0935 1.31703 24.0935 1.70756 23.703L6.00092 19.41C6.04461 19.572 6.06847 19.7422 6.06973 19.9177L6.09515 23.4544C6.09935 24.0382 6.93017 24.1426 7.07869 23.578Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9228 0.417798L14.9836 7.79051C14.7888 8.53113 15.4647 9.20688 16.2053 9.01193L23.5765 7.07151C24.1412 6.92287 24.0366 6.09203 23.4527 6.088L19.9179 6.0636C19.7451 6.06241 19.5775 6.03932 19.4177 5.99696L23.7081 1.70703C24.0986 1.31651 24.0986 0.683346 23.7081 0.292813C23.3176 -0.0977193 22.6844 -0.0977336 22.2939 0.292782L18.0005 4.58573C17.9568 4.42372 17.933 4.25357 17.9317 4.07802L17.9063 0.541387C17.9021 -0.0424886 17.0713 -0.146886 16.9228 0.417798Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.0787 0.417799L9.01785 7.79051C9.21264 8.53113 8.53674 9.20688 7.79617 9.01193L0.424943 7.07151C-0.139732 6.92287 -0.0351226 6.09203 0.548776 6.088L4.08359 6.0636C4.25639 6.06241 4.42398 6.03932 4.58373 5.99696L0.293379 1.70703C-0.0971539 1.31651 -0.0971682 0.683345 0.293347 0.292813C0.683863 -0.0977199 1.31703 -0.0977342 1.70756 0.292781L6.00092 4.58573C6.04461 4.42372 6.06847 4.25357 6.06973 4.07802L6.09516 0.541387C6.09935 -0.0424884 6.93017 -0.146886 7.0787 0.417799Z",
			fill: "white"
		})
	]
});
export default SvgIconReduce;
